import http from './httpClient';

export const getListSpecialities = async (page) => {
  try {
    const { data } = await http.get('/specialities/', {
      params: {
        page,
      },
    });
    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * Pega os dados da consulta.
 * @param {String} cod
 * @param {String} id
 */
export const getDetails = async (cod, id) => {
  const result = http.get(`/psychologists/${cod}/appointments/${id}/`, {
    headers: {
      Authorization: `Token ${localStorage.getItem('user-token')}`,
    },
  });
  return result;
};

/**
 * Pega uma quantidade limitada de todas as consultas
 * a partir da date/hora atual
 * @param {String} cod
 * @param {Date} date
 * @param {Number} limit
 */
export const getConsultations = async (cod, date, limit) => {
  try {
    const { data } = await http.get(`/psychologists/${cod}/appointments/`, {
      params: {
        after_date_time: date,
        limit,
        with_chief_therapist: true,
      },
    });
    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getIndexMedicalRecord = async (id) => {
  try {
    const res = await http.get(`/medical_record/${id}/`, {
      headers: { Authorization: `Token ${localStorage.getItem('user-token')}` },
    });
    return Promise.resolve(res);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getAllMedicalRecords = async (dataParams) => {
  try {
    const res = await http.get('/medical_record/', {
      params: {
        initial_date: dataParams.initialDate,
        final_date: dataParams.finalDate,
        name: dataParams.name,
      },
      headers: { Authorization: `Token ${localStorage.getItem('user-token')}` },
    });
    return Promise.resolve(res);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const createMedicalRecords = async (medicalForm) => {
  try {
    const { data } = await http.post('/medical_record/', medicalForm, {
      headers: { Authorization: `Token ${localStorage.getItem('user-token')}` },
    });
    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const patchMedicalRecords = async (medicalForm, medicalRecordId) => {
  try {
    const { data } = await http.patch(`/medical_record/${medicalRecordId}/`, medicalForm, {
      headers: { Authorization: `Token ${localStorage.getItem('user-token')}` },
    });
    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const uploadStripeDocument = async (blob, apiKey, purposeValue) => {
  const fd = new FormData();
  fd.set('purpose', purposeValue);
  fd.set('file', blob);
  return fetch('https://files.stripe.com/v1/files', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${apiKey}`,
    },
    body: fd,
  })
    .then((r) => r.json())
    .then((response) => response.id);
};

/**
 * Pega uma consulta
 * @param {String} cod
 */
export const getSingleAppointment = async (cod, appointmentId) => {
  try {
    const result = await http.get(`/psychologists/${cod}/appointments/${appointmentId}/`);
    return Promise.resolve(result);
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * Pega as consultas do dia atual e devolve a quantidade de consultas.
 * @param {String} cod
 * @param {Date} date
 */
export const getConsultationsNow = async (cod, date) => {
  try {
    const result = await http.get(`/psychologists/${cod}/appointments/`, {
      params: {
        date,
        with_chief_therapist: true
      },
    });
    return Promise.resolve(result);
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * Pega o total de paciente de um psicologo.
 * @param {String} cod
 */
export const totalPatients = async (cod) => {
  try {
    const { data } = await http.get(`/psychologists/${cod}/patients/`);
    const total = (data[1] && data[1].length) || 0;
    return Promise.resolve(total);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const updateAppointmentDate = async (data, idAppointment) => {
  try {
    const token = await localStorage.getItem('user-token');
    const result = await http.patch(`appointments/${idAppointment}/`, data, {
      headers: { Authorization: `Token ${token}` },
    });
    return Promise.resolve(result);
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * Pega a classificação média do psicologo.
 * @param {String} cod
 */
export const average = async (cod) => {
  try {
    const { data } = await http.get(`/psychologists/${cod}/assessments/average/`);
    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const signUp = async (user, specialities) => {
  try {
    const { data } = await http.post('/psychologists/', user);
    await http.post(
      `/psychologists/${data.id}/specialities/`,
      {
        id: specialities,
      },
      {
        headers: { Authorization: `Token ${data.token}` },
      },
    );
    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const sendTherapistInterviewForm = async (form) => {
  try {
    const result = await http.post('/psychologist_questions/', form, {
      Authorization: `Token ${localStorage.getItem('user-token')}`,
    });
    return Promise.resolve(result);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const checkPsychologistSlug = async (slug) => {
  try {
    const result = await http.get(`/psychologist-by-slug/${slug}`);
    return Promise.resolve(result);
  } catch (error) {
    return Promise.reject(error.response);
  }
};

/**
 * Metodo que pegar os dados do psicologo (perfil, especialidades e media de avaliação)
 * e retornar como array.
 * @param {String} cod
 */
export const getProfile = async (cod, changeLocalStorageData=false) => {
  try {
    const { data: user } = await http.get(`/psychologists/${cod}/`);
    
    if (user.digital_account && user.digital_account.routing_number && user.digital_account.routing_number.includes('[')) {
      Object.entries(user.digital_account).map(([key, value]) => {
        user.digital_account[key] = value.replace(/\['/g, '').replace(/'\]/g, '')
      })
    }
    if (changeLocalStorageData) {
      localStorage.setItem('user-data', JSON.stringify(user));
    }
    return Promise.resolve(user);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const profileWithSlug = async (cod) => {
  try {
    const { data: user } = await http.get(`/psychologist-by-slug/${cod}/`);
    const res = user;

    return Promise.resolve(res);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const createSchedule = async (cod, list) => {
  const token = await localStorage.getItem('user-token');
  const result = await http.post(
    `/psychologists/${cod}/time_slots/`,
    {
      list,
    },
    {
      headers: { Authorization: `Token ${token}` },
    },
  );

  return result;
};

export const createBankAccount = async (data) => {
  try {
    const token = await localStorage.getItem('user-token');
    let result;

    if (data.empresaOuEni == 'individual'){
         result = await http.post('/digital_account/', data, {
        headers: { Authorization: `Token ${token}`,
        'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW' }});
    } else {
         result = await http.post('/digital_account/', data, {
        headers: { Authorization: `Token ${token}`}});
    }
    return Promise.resolve(result);
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const editBankAccount = async (data) => {
  try {
    const token = await localStorage.getItem('user-token');
    const result = await http.patch('/edit_bank_account/', data, {
      headers: { Authorization: `Token ${token}` },
    });
    return Promise.resolve(result);
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const deleteSchedule = async (cod, date) => {
  const result = await http.delete(`/psychologists/${cod}/time_slots/`, {
    headers: {
      Authorization: `Token ${localStorage.getItem('user-token')}`,
    },
    params: {
      date,
    },
  });
  return result;
};

export const getSchedule = async (cod, date) => {
  const result = await http.get(`/psychologists/${cod}/time_slots/`, {
    params: {
      date,
    },
    headers: {
      Authorization: `Token ${localStorage.getItem('user-token')}`,
    },
  });
  return result;
};
